<mat-form-field appearance="outline" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip" matTooltipPosition="above"
  matTooltipClass="sl-tooltip">
  <mat-label>
    {{label}} <app-required *ngIf="isRequired()"></app-required>
  </mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="control" [placeholder]="placeholder" (focus)="picker.open()"
    [min]="minDate? minDate: ''" [max]="maxDate? maxDate: ''">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <ng-container *ngIf="control && control.invalid" ngProjectAs="mat-error">
    <mat-error *ngIf="control.hasError('required')"> {{label}} is <strong>required</strong>. </mat-error>
    <mat-error *ngIf="control.hasError('invalid')"> {{errMsg ? errMsg : 'Invalid'}} </mat-error>
  </ng-container>
  <ng-container ngProjectAs="mat-hint">
    <mat-hint *ngIf="hint">{{hint}}</mat-hint>
  </ng-container>
</mat-form-field>
